import { apiGetOneOrNull, apiListAll } from '@/core/api/resources'
import type { PersonCoachingRecords } from '@/core/data/person'

export async function getPersonRecords(id: string): Promise<PersonCoachingRecords> {
  const [coaching, documents] = await Promise.all([
    apiGetOneOrNull('/azav/coaching/{id}', { id }),
    apiListAll('/azav/dokumente', { coaching_id: id, include: ['signatur', 'sitzung'] }),
  ])
  const sessions = documents.length ? await apiListAll('/azav/sitzung', {
    dokument_id__in: documents.map((doc) => doc.id), include: ['anwesenheit', 'modul'],
  }) : []
  return { coaching, documents, sessions }
}
